<template>
  <div class="space-y-6">
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        SEO Access Statuses
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <UiControl id="seo-access-gbp" label="GBP Access">
          <UiSelect
            id="seo-access-gbp-select"
            v-model="form.gbp_access"
            :options="accessOptions"
          />
        </UiControl>
        <UiControl id="seo-access-ga4" label="GA4 Access">
          <UiSelect
            id="seo-access-ga4-select"
            v-model="form.ga4_access"
            :options="accessOptions"
          />
        </UiControl>
        <UiControl id="seo-access-gsc" label="GSC Access">
          <UiSelect
            id="seo-access-gsc-select"
            v-model="form.gsc_access"
            :options="accessOptions"
          />
        </UiControl>
      </div>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-6">
      <h3 class="text-lg font-medium font-poppins text-gray-900 dark:text-gray-100 mb-4">
        Call Tracking Details
      </h3>
      <UiControl id="seo-access-call-tracking" label="Call Tracking Details">
        <UiTextarea
          v-model="form.call_tracking_details"
          placeholder="Provide any relevant call tracking details, account numbers, or configuration notes..."
        />
      </UiControl>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import UiControl from '~/javascript/components/ui/form/control/control.vue'
import UiSelect from '~/javascript/components/ui/form/select/select.vue'
import UiTextarea from '~/javascript/components/ui/form/textarea/textarea.vue'

const props = defineProps({
  stepKey: { type: String, required: true },
  label: { type: String, required: true },
  onboarding: { type: Object, required: true },
  mode: { type: String, required: true }
})

const accessOptions = [
  { id: 'have_access', title: 'Have Access' },
  { id: 'need_access', title: 'Need Access' },
  { id: 'unsure', title: 'Unsure' }
]

const form = ref({
  gbp_access: '',
  ga4_access: '',
  gsc_access: '',
  call_tracking_details: ''
})

onMounted(() => {
  const d = props.onboarding.seo_detail || {}
  form.value.gbp_access = d.gbp_access || ''
  form.value.ga4_access = d.ga4_access || ''
  form.value.gsc_access = d.gsc_access || ''
  form.value.call_tracking_details = d.call_tracking_details || ''
})

defineExpose({
  getData: () => ({ ...form.value })
})
</script>
